import { render } from "./GameHeader.vue?vue&type=template&id=29d3e30e&scoped=true"
import script from "./GameHeader.vue?vue&type=script&lang=js"
export * from "./GameHeader.vue?vue&type=script&lang=js"

import "./GameHeader.vue?vue&type=style&index=0&id=29d3e30e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d3e30e"]])

export default __exports__